import React from 'react';

const Footer = () => {
  return (
    <footer
      id="sticky-footer"
      className="py-3 bg-light text-black-100 mt-4 footer"
    >
      <div className="container text-center">
        <small>
          Copyright &copy;{`${new Date().getFullYear()} `}
          <a
            href="https://www.4case.com.br/"
            target="_blank"
            rel="noopener noreferrer"
          >
            4Case Solutions
          </a>
        </small>
      </div>
    </footer>
  );
};

export default Footer;
